import { Breadcrumb, Card, Tooltip } from "antd";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

interface BreadCrampType {
  url?: string;
  icon?: React.ReactNode;
  title?: string;
}
interface Props {
  heading: string;
  info?: string;
  breadcrumbs?: BreadCrampType[];
  classes?: string;
  extraStartBtn?: any;
}

export const Header: React.FC<Props> = ({
  heading,
  info,
  breadcrumbs,
  classes,
  extraStartBtn,
}) => {
  return (
    <Card className={classes}>
      <div className="d-flex header-container">
        <h1 className="gray-gray-9 page-title">
          {heading}{" "}
          {info && (
            <Tooltip placement="topLeft" title={info}>
              <InfoCircleOutlined />
            </Tooltip>
          )}
          {extraStartBtn ? extraStartBtn : ""}
        </h1>
        <div className="breadcrumb-container">
          <Breadcrumb>
            {breadcrumbs &&
              breadcrumbs.map((breadcrumb: BreadCrampType) => {
                return (
                  <Breadcrumb.Item href={breadcrumb.url}>
                    {breadcrumb.icon ? breadcrumb.icon : ""}
                    <span>{breadcrumb.title}</span>
                  </Breadcrumb.Item>
                );
              })}
          </Breadcrumb>
        </div>
      </div>
    </Card>
  );
};
